import _ from 'lodash'
import WidgetModel from '../widget-model'

// eslint-disable-next-line no-unused-vars
import ChartData from 'scoreboard/charts/chart-data/chart-data'

import ChartDesigner from 'scoreboard/charts/model/chart-designer'
import ChartWidgetView from 'scoreboard/dashboards/widgets/chart/chart-widget-view'
import nestModel from 'scoreboard/components/nest-model'

var ChartWidgetModel = WidgetModel.extend({
	/** @type ChartDesigner */
	chart: null,

	// If these change, update WIDGET_DIMENSIONS in DashboardBuilder.kt
	containerDefaults: {
		width: 480,
		height: 330
	},

	viewCls: ChartWidgetView,

	multiSettableProps: [ 'background' ],

	initialize: function(attr, options = {}) {
		WidgetModel.prototype.initialize.apply(this, arguments)
		if (this.options.chart) {
			// For a new chart widget, the ChartDesigner will be passed in
			this.chart = this.options.chart
		} else {
			if (this.attributes.chart) {
				// This is how dashboard history re-creates a deleted widget on redo
				this.chart = new ChartDesigner(this.attributes.chart, {
					data: new ChartData({
						data: this.attributes.chart.data,
						dashboardData: this.data
					})
				})
			} else {
				// For an existing chart widget, the ChartDesigner and ChartData
				// are in unparsed form in the DashboardData, so we need to create
				// them with their constructors
				let rawData = this.data.chartDataByIds(this.chartIds())
				let chartOptions = {
					data: new ChartData({
						data: rawData,
						dashboardData: this.data
					})
				}

				this.chart = new ChartDesigner(
					this.data.chartDesignersByIds(this.chartIds()),
					chartOptions)
			}
		}

		nestModel({
			parent: this,
			parentAttribute: 'chart',
			child: this.chart
		})

		// Undo/Redo functionality requires that attributes be set in this way
		// in order to work consistently
		this.set('chart', this.chart.attributes)

		var originalFetchOptions = this.data.fetchOptions.bind(this)
		this.data.fetchOptions = function (opt) {
			// The fetchOptions that WidgetModel uses is close to what we need,
			// but we need to add the chart to the POST data
			var fetchOpt = originalFetchOptions(opt)
			var postData = JSON.parse(fetchOpt.data)

			// postData[0] will be this widget, because WidgetModel only attempts
			// to fetch data for itself
			_.extend(postData.widgets[0], {
				chart: this.chart.toPostJSON()
			})

			postData.drilldownIdsByFieldId = this.maestro().drilldownIdsByFieldId()

			fetchOpt.data = JSON.stringify(postData)

			return fetchOpt
		}.bind(this)

		// Widget stuff is dependant on the direct '.chart' property, so it must be
		// kept in-sync with this.get('chart').
		// It MUST NOT be reassigned or breakage to canvas undo/redo will occur.
		this.on('change:chart', () => {
			this.chart.set(this.get('chart'))
		})
	},

	fetchChart ({ periodId }) {
		return this.chart.data.fetch({
			periodId,
			chart: this.chart,
			liveFilters: this.maestro().liveFilters(),
			drilldownId: this.drilldownFieldAndId()?.drilldownId,
			zoomToIds: this.chart.data.currentDrilldown()?.zoomToIds()
		})
	},

	drilldownFieldAndId () {
		return this.chart.drilldownFieldAndId()
	},

	/**
	 * Returns the id and/or tempId of the chart
	 * @return {{id: Integer, tempId: String}}
	 */
	chartIds () {
		let chartId = this.properties.get('chartId')
		return {
			id: _.isNil(chartId) ? null : parseInt(chartId),
			tempId: this.properties.get('chartTempId')
		}
	},

	datasetId () {
		return this.chart.startingDataset()?.id
	}
})

export default ChartWidgetModel
ChartWidgetModel.__filename__ = 'dashboards/widgets/chart/chart-widget-model.js'
